<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { t } from 'svelte-i18n';
	import { capitalize } from '@wiseed/wikit';
	import { Carousel } from '@wiseed/wikit';
	import { CarouselControls } from '@wiseed/wikit';
	import ProjectDevelopmentStepsItem from './ProjectDevelopmentStepsItem.svelte';

	export let operation: OperationModel;
	export let title: string = null;

	let slides;

	const sliderConfig = {
		gap: 30,
		perView: 4,
		bound: true,
		breakpoints: {
			1024: {
				gap: 15,
				perView: 3
			},
			767: {
				gap: 15,
				perView: 2
			}
		}
	};

	if (operation.developmentSteps && operation.developmentSteps.length > 0) {
		slides = operation.developmentSteps.map((step) => {
			return {
				component: ProjectDevelopmentStepsItem,
				props: {
					props: {
						date: step.labelDate,
						text: step.description
					}
				}
			};
		});
	}
</script>

{#if slides && slides.length > 0}
	<section>
		<h2>{capitalize(title ?? $t('operation.developmentSteps'))}</h2>
		<div
			class="relative bg-dashboardBg py-4 rounded-lg before:absolute before:h-px before:w-full before:bg-primary before:top-[72px] before:left-0"
		>
			<Carousel {slides} config={sliderConfig} controls swipe breakpoints positionControls="bottom">
				<div class="container md:text-right pt-4" slot="controls">
					<CarouselControls next prev rounded classNames="inline-block" />
				</div>
			</Carousel>
		</div>
	</section>
{/if}
